import React from "react";
import "./legal.css";
import Footer from "./Footer";

const TermsOfService = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Terms of Service</h1>

        <p className="legal-updated">Last Updated: June 18, 2026</p>

        <section>
          <h2>1. Acceptance of Terms</h2>

          <p>
            By accessing or using KostPadi, you agree to comply with these Terms
            of Service.
          </p>
        </section>

        <section>
          <h2>2. Services</h2>

          <p>
            KostPadi provides cloud-based accounting, invoicing, inventory,
            reporting, and financial management tools for businesses.
          </p>
        </section>

        <section>
          <h2>3. User Responsibilities</h2>

          <ul>
            <li>Provide accurate account information</li>
            <li>Maintain confidentiality of login credentials</li>
            <li>Use the platform lawfully</li>
            <li>Not engage in fraudulent activity</li>
          </ul>
        </section>

        <section>
          <h2>4. Payments & Subscriptions</h2>

          <p>
            Paid subscriptions are billed according to selected plans. Failure
            to pay may result in suspension or termination of services.
          </p>
        </section>

        <section>
          <h2>5. Intellectual Property</h2>

          <p>
            All platform content, branding, software, and designs remain the
            property of KostPadi unless otherwise stated.
          </p>
        </section>

        <section>
          <h2>6. Limitation of Liability</h2>

          <p>
            KostPadi shall not be liable for indirect, incidental, or
            consequential damages arising from platform usage.
          </p>
        </section>

        <section>
          <h2>7. Termination</h2>

          <p>
            We reserve the right to suspend or terminate accounts that violate
            these terms or applicable laws.
          </p>
        </section>

        <section>
          <h2>8. Governing Law</h2>

          <p>
            These Terms shall be governed by the laws of the Federal Republic of
            Nigeria.
          </p>
        </section>

        <section>
          <h2>9. Contact</h2>

          <p>Email: support@kostpadi.com</p>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default TermsOfService;
